import React from "react";
import { ArrowRight } from "lucide-react";

import { Badge } from "../../ui/badge";
import { Button } from "../../ui/button";
import { getStakeholderLaneAppearance, LANE_STATUS_META } from "../config/stakeholderLaneConfig";

export default function StakeholderLaneHeader({ lane, onOpenLane }) {
  const statusMeta = LANE_STATUS_META[lane.status];
  const appearance = getStakeholderLaneAppearance(lane.id);

  return (
    <div className="space-y-3 border-b border-slate-200/80 pb-4 dark:border-white/10">
      <div className="flex items-start justify-between gap-3">
        <div>
          <button
            className="group inline-flex items-center gap-2 text-left"
            onClick={() => onOpenLane?.(lane.id)}
            type="button"
          >
            <h2 className={`text-lg font-semibold text-slate-950 transition-colors dark:text-white ${appearance.titleHoverClass}`}>
              {lane.title}
            </h2>
            <ArrowRight className={`h-4 w-4 text-slate-400 transition-transform group-hover:translate-x-0.5 ${appearance.iconHoverClass}`} />
          </button>
          <p className="mt-1 text-sm leading-6 text-slate-600 dark:text-slate-300">{lane.promise}</p>
        </div>
        <Badge className={`shrink-0 border ${statusMeta.className}`}>{statusMeta.label}</Badge>
      </div>

      <div className="flex justify-start">
        <Button onClick={() => onOpenLane?.(lane.id)} size="sm" variant="ghost">
          Open lane detail
        </Button>
      </div>

      <div className="grid grid-cols-3 gap-2">
        <div className={`rounded-xl border px-3 py-2 ${appearance.statClass}`}>
          <p className="text-[10px] font-semibold uppercase tracking-[0.18em] text-slate-500 dark:text-slate-400">
            Needs
          </p>
          <p className="mt-1 text-lg font-semibold text-slate-900 dark:text-white">{lane.counts["needs-now"]}</p>
        </div>
        <div className={`rounded-xl border px-3 py-2 ${appearance.statClass}`}>
          <p className="text-[10px] font-semibold uppercase tracking-[0.18em] text-slate-500 dark:text-slate-400">
            Moving
          </p>
          <p className="mt-1 text-lg font-semibold text-slate-900 dark:text-white">{lane.counts.moving}</p>
        </div>
        <div className={`rounded-xl border px-3 py-2 ${appearance.statClass}`}>
          <p className="text-[10px] font-semibold uppercase tracking-[0.18em] text-slate-500 dark:text-slate-400">
            Watch
          </p>
          <p className="mt-1 text-lg font-semibold text-slate-900 dark:text-white">{lane.counts.watch}</p>
        </div>
      </div>

      {(lane.overdueCount || lane.dueTodayCount) ? (
        <div className="flex flex-wrap gap-2">
          {lane.overdueCount ? <Badge variant="outline">{lane.overdueCount} overdue</Badge> : null}
          {lane.dueTodayCount ? <Badge variant="outline">{lane.dueTodayCount} due today</Badge> : null}
        </div>
      ) : null}
    </div>
  );
}
